import {html, css} from "@isceco/widget-library2/external/lit";
import WebComponent from "../../WebComponent";
import VerfuegungColumns from "./VerfuegungColumns";
import BerechtigteListService from "../../services/BerechtigteListService";
import KontingentService from "../../services/KontingentService";
import KontingentperiodeService from "../../services/KontingentperiodeService";
import KontingentperiodeDto from "../Dashboard/KontingentperiodeDto";
import KontingentDto from "./KontingentDto";
import {List} from "@isceco/widget-library2/basic-elements/List/List";

import '@isceco/widget-library2/basic-elements/Title/Title.js'
import '@isceco/widget-library2/basic-elements/Filter/FilterGroup.js'
import '@isceco/widget-library2/basic-elements/Filter/StringFilter.js'
import '@isceco/widget-library2/basic-elements/Filter/SingleselectFilter'
import '@isceco/widget-library2/basic-elements/Filter/CheckboxFilter'
import '@isceco/widget-library2/basic-elements/ModalDialog/ModalDialog'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput'
import '@isceco/widget-library2/basic-elements/Textarea/Textarea'
import '@isceco/widget-library2/basic-elements/Form/Form'
import NumberUtil from "../../services/NumberUtil";


const VERSAND_ELEKTRONISCH = 'elektronisch'
const VERSAND_BRIEF = 'brief'

export default class VerfuegungNeu extends WebComponent {

  constructor() {
    super()
    this.kontingentService = new KontingentService()
    this.kontingentperiodeService = new KontingentperiodeService()
    this.wertAnpassen = null
  }

  get translationFile() {
    return './views/Verfuegung/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.kontingentperiodeService.read(getNavigationId()),
      this.kontingentService.getBackendListUrl()
    ]).then(([periode, url]) => {
      this.periode = new KontingentperiodeDto(periode)
      this.url = constructURL({to: url, params: {periodeId: getNavigationId(), status: 'NEU'}})
      this.render()
    }).catch(_ => {
      this.periode = new KontingentperiodeDto()
      this.url = ''
      this.render()
    })
  }

  get css() {
    return css`
      #wert-anpassen-dialog-content {
        display: grid;
        grid-template-areas:
          "berechneterWert angepassterWert"
          "angepasstKommentar angepasstKommentar";
      }
    `
  }

  getTemplate() {
    const start = formatDate(this.periode.start)
    const ende = formatDate(this.periode.ende)
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate(`verfuegung.neu.uebersicht.title`, {start, ende})}">
        <div style="display: flex; justify-content: center; align-items: center;">
          <isceco-button size="small" variant="primary"
                         text="${this.i18n.translate('verfuegung.button.versenden.bulk.elektronisch')}"
                         @click="${_ => this._toggleVersenden(VERSAND_ELEKTRONISCH)}"
          ></isceco-button>
          <isceco-button size="small" variant="primary" style="margin-left: 10px;"
                         text="${this.i18n.translate('verfuegung.button.versenden.bulk.brief')}"
                         @click="${_ => this._toggleVersenden(VERSAND_BRIEF)}"
          ></isceco-button>
        </div>
      </isceco-title>
      <isceco-filter-group>
        <isceco-string-filter label="${this.i18n.translate('verfuegung.filter.freitext')}"
                              key="freitext"
        ></isceco-string-filter>
        <isceco-checkbox-filter label="${this.i18n.translate('verfuegung.filter.angepasst')}"
                                key="angepasst"
        ></isceco-checkbox-filter>
        <isceco-singleselect-filter label="${this.i18n.translate('verfuegung.filter.versandart')}"
                                    key="elektronischeVerfuegung"
                                    .items="${[
                                      {value: 'true', name: this.i18n.translate('verfuegung.filter.versandart.elektronisch')},
                                      {value: 'false', name: this.i18n.translate('verfuegung.filter.versandart.brief')}
                                    ]}"
        ></isceco-singleselect-filter>
      </isceco-filter-group>
      <isceco-list url="${this.url}"
                   identifier="kontingent"
                   .listService="${BerechtigteListService}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this.toDTO}"
                   .columns="${VerfuegungColumns.getNeuColumns(this._preview, this._toggleVersenden, this._toggleWertAnpassen)}"
      ></isceco-list>
      ${this._renderWertAnpassenDialog()}
      ${this._renderConfirmVersendenDialog()}
    `
  }

  _renderWertAnpassenDialog() {
    if (this.wertAnpassen) {
      return html`
        <isceco-dialog id="wert-anpassen-dialog"
                       @submit="${e => this._handleWertAnpassen(e.detail)}"
                       header="${this.i18n.translate('verfuegung.neu.anpassen.title')}"
                       confirm-button="${this.i18n.translate('base.button.submit')}"
                       cancel-button="${this.i18n.translate('base.button.cancel')}">
          <isceco-form id="wert-anpassen-form">
            <div id="wert-anpassen-dialog-content" slot="form-elements">
              <isceco-text-input label="${this.i18n.translate('verfuegung.neu.anpassen.berechneterWert')}"
                                 name="berechneterWert"
                                 value="${this.i18n.translate('verfuegung.format.wert', {wert: NumberUtil.format(this.wertAnpassen.berechneterWert ?? '—')})}"
                                 style="grid-area: berechneterWert"
                                 readonly
              ></isceco-text-input>
              <isceco-number-input label="${this.i18n.translate('verfuegung.neu.anpassen.angepassterWert')}"
                                 name="angepassterWert"
                                 value="${this.wertAnpassen.angepassterWert}"
                                 style="grid-area: angepassterWert"
                                 maximum-fraction-digits="2"
                                 min="0" max="999999.99"
                                 required
              ></isceco-number-input>
              <isceco-textarea label="${this.i18n.translate('verfuegung.neu.anpassen.angepasstKommentar')}"
                               name="angepasstKommentar"
                               value="${this.wertAnpassen.angepasstKommentar}"
                               style="grid-area: angepasstKommentar"
                               maxlength="255"
                               resize="auto"
                               required
              ></isceco-textarea>
            </div>
          </isceco-form>
        </isceco-dialog>
      `
    }
    return html``
  }

  _renderConfirmVersendenDialog() {
    if (!this.kontingentVersenden) {
      return html``
    }
    let versandTyp = typeof this.kontingentVersenden === 'string' ? `bulk.${this.kontingentVersenden}` : 'single.'
    if (typeof this.kontingentVersenden === 'object') {
      versandTyp += this.kontingentVersenden.elektronischerVersand ? VERSAND_ELEKTRONISCH : VERSAND_BRIEF
    }
    return html`
      <isceco-dialog id="versenden-dialog"
                     header="${this.i18n.translate(`verfuegung.neu.versenden.${versandTyp}.title`, {gp: this.kontingentVersenden?.gp})}"
                     description="${this.i18n.translate(`verfuegung.neu.versenden.${versandTyp}.description`, {gp: this.kontingentVersenden?.gp})}"
                     confirm-button="${this.i18n.translate(`verfuegung.neu.versenden.${versandTyp}.button`)}"
                     cancel-button="${this.i18n.translate('base.button.cancel')}"
                     @submit="${e => this._handleVersenden(e.detail)}"
      ></isceco-dialog>
    `
  }

  _handleWertAnpassen(event) {
    if (!event.confirmed) {
      this._toggleWertAnpassen(null)
      return
    }
    const form = document.getElementById('wert-anpassen-form')
    if (form.validate()) {
      const obj = form.getValues()
      obj.id = this.wertAnpassen.id
      this.kontingentService.update(obj).then(json => {
        const kontingent = new KontingentDto(json)
        window.showAlert(this.i18n.translate('verfuegung.neu.anpassen.alert.success', {gp: kontingent.gp, wert: kontingent.angepassterWert}), "", 'success')
        send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'kontingent'})
      })
      this._toggleWertAnpassen(null)
    }
  }

  _handleVersenden(event) {
    const queryParams = document.querySelector('isceco-list[identifier=kontingent]').queryParams

    if (!event.confirmed) {
      this._toggleVersenden(null)
    } else if (typeof this.kontingentVersenden === 'string') {
      const filename = formatDate(this.periode.start)
      this.kontingentperiodeService.neueVersenden(this.periode, this.kontingentVersenden === VERSAND_ELEKTRONISCH, queryParams)
        .then(response => response.headers.get('Content-Type') === 'application/zip' ? response.blob() : null)
        .then(zip => zip ? download(toValidFilename(filename, 'zip'), zip) : null)
        .then(_ => {
          window.showAlert(this.i18n.translate(`verfuegung.neu.versenden.bulk.${this.kontingentVersenden}.alert.success`), "", 'success')
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'kontingent'})
          this._toggleVersenden(null)
        })
    } else {
      const filename = `${this.kontingentVersenden.geschaeftspartner.extId}_${this.kontingentVersenden.gp}_${formatDate(this.kontingentVersenden.periode.start)}`
      this.kontingentService.versenden(this.kontingentVersenden)
        .then(response => response.headers.get('Content-Type') === 'application/pdf' ? response.blob() : null)
        .then(pdf => pdf ? download(toValidFilename(filename, 'pdf'), pdf) : null)
        .then(_ => {
          window.showAlert(this.i18n.translate('verfuegung.neu.versenden.single.alert.success', {gp: this.kontingentVersenden.gp}), "", 'success')
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'kontingent'})
          this._toggleVersenden(null)
        })
    }
  }

  _preview = kontingentDto => {
    const filename = `${kontingentDto.geschaeftspartner.extId}_${kontingentDto.gp}_${formatDate(kontingentDto.periode.start)}`
    this.kontingentService.read(kontingentDto.id, 'pdf')
      .then(response => response.blob())
      .then(blob => download(toValidFilename(filename, 'pdf'), blob))
  }

  _toggleWertAnpassen = kontingentDto => {
    this.wertAnpassen = kontingentDto
    this.reload()
  }

  _toggleVersenden = target => {
    this.kontingentVersenden = target;
    this.render()
  }

  toDTO = row => new KontingentDto(row)
}
customElements.define('eko-frontend-verfuegung-neu', VerfuegungNeu)
